query allFeeds {
	allFeeds(
    condition: {
      available: true
    }
  ) {
    nodes {
      feed
      isPrimary
      status
      updatedAt
      available
    }
  }
}
